export default {
  getLatestUploads: 'getLatestUploads',
  getNewCases: 'getNewCases',
  getAssetsForDashboard: 'getAssetsForDashboard',
};
